(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/game-package/assets/react/components/size-picker.js') >= 0) return;  svs.modules.push('/modules/game-package/assets/react/components/size-picker.js');

'use strict';

const {
  RadioGroup,
  RadioButton
} = svs.ui.reactForm;
const {
  useDispatch,
  useSelector
} = ReactRedux;
const {
  updateIndex
} = svs.gamePackage.redux.gamePackageSlice.actions;
const SizePicker = () => {
  const {
    activeIndex,
    sizes
  } = useSelector(state => state.gamePackage);
  const dispatch = useDispatch();
  return React.createElement("div", {
    className: "gp-size-picker-container"
  }, React.createElement(RadioGroup, {
    size: "200"
  }, sizes.map(_ref => {
    let {
      label,
      price,
      index
    } = _ref;
    return React.createElement(RadioButton, {
      checked: index === activeIndex,
      onChange: () => dispatch(updateIndex({
        activeIndex: index
      })),
      name: "size-picker[]",
      value: index,
      key: label
    }, "".concat(label, " ").concat(price, " kr"));
  })));
};
svs.gamePackage.components.SizePicker = SizePicker;

 })(window);